import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IMessageStatusProps from "./type";
import stylesheet, {
    MESSAGE_STATUS_TEXT_COLORS,
    MESSAGE_STATUS_ICON_COLORS,
    MESSAGE_STATUS_TEXT_KEYS,
    MESSAGE_STATUS_ICONS,
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import AnimatedIcon from "../../../animatedIcon";
import Button from "../../../button";
import Text from "../../../text";

const MessageStatus: FC<IMessageStatusProps> = ({
    customLocalize,
    customTheme,
    onRetry,
    status,
    style
}) => {
    const {
        controlHeights,
        shapeConfigs,
        typography,
        iconSizes,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(customLocalize);

    const {
        container: containerDynamicStyle,
        retry: retryDynamicStyle
    } = useStyles({
        controlHeights,
        typography,
        spaces
    });

    return <View
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        <AnimatedIcon
            size={iconSizes.small - shapeConfigs.chipIconOffset}
            color={MESSAGE_STATUS_ICON_COLORS[status]}
            icon={MESSAGE_STATUS_ICONS[status]}
            customTheme={customTheme}
            iconTransition="morph"
        />
        <Text
            color={MESSAGE_STATUS_TEXT_COLORS[status]}
            customTheme={customTheme}
            variant="bodySmallSize"
            style={stylesheet.text}
            numberOfLines={1}
        >
            {localize(MESSAGE_STATUS_TEXT_KEYS[status])}
        </Text>
        {
            status === "failed" && onRetry ?
                <Button
                    title={localize("try-again")}
                    customTheme={customTheme}
                    style={retryDynamicStyle}
                    onPress={onRetry}
                    variant="ghost"
                    type="danger"
                    size="small"
                />
            :
                null
        }
    </View>;
};
export default MessageStatus;
